import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ProductGridItem
  from './ProductGridItem.js';
import EmailBack from '../EmailBack/EmailBack';
import { ProductBriefDescription } from '../ProductBriefDescription/ProductBriefDescription';

import { getTranslation } from '../../translations/translations';
import {
  convertDefaultChannelsAvailabilityForSponsoredProduct,
  getDefaultDeliveriesAndCollectionForProduct
} from '../../dataConverters/defaultChannelsAvailabilitiesConverter';

import { updateHeightsOfOneGridRow } from './productGridRowHeightUpdater';


const ProductGridRow = ({ firstGridRow, countdownClassSuffix, dataInteraction, rowProductsList,
  briefDescriptionProductID, emailWhenBackFormProductID }) => {
  const [wasInViewport, setWasInViewport] = useState(false);

  // update heights when grid row gets to viewport of the browser
  // or when channels availabilities change by postcode checker search
  useEffect(() => {
    if (wasInViewport) {
      // update heights of grid row in order the each product grid item has the same height
      updateHeightsOfOneGridRow(
        rowProductsList.map((product) => `id${product.id}${product.sponsored ? '-sponsored' : ''}`)
      );
    }
  }, [wasInViewport, rowProductsList[0].placeSpecificChannelsAvailability]);

  // update heights on resize of the browser window
  useEffect(() => {
    const onResize = () => {
      updateHeightsOfOneGridRow(
        rowProductsList.map((product) => `id${product.id}${product.sponsored ? '-sponsored' : ''}`)
      );
    };

    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  });


  const productGridRow = [];
  rowProductsList.forEach((currentProduct, index) => {
    // eslint-disable-next-line no-nested-ternary
    const gridItemRowLocation = index === 0 ? 'left' : (index === rowProductsList.length - 1 ? 'right' : 'middle');

    productGridRow.push(
      <ProductGridItem
        {...currentProduct}
        onGetToViewport={
          index === 0
            ? () => { setWasInViewport(true); }
            : undefined
        }
        defaultChannelsAvailability={
            currentProduct.sponsored
              ? convertDefaultChannelsAvailabilityForSponsoredProduct(currentProduct.deliveryOptions)
              : getDefaultDeliveriesAndCollectionForProduct(currentProduct)
          }
        loadImages={firstGridRow || wasInViewport}
        countdownClassSuffix={countdownClassSuffix}
        key={`id${currentProduct.id}${currentProduct.sponsored ? '-sponsored' : ''}`}
        gridItemRowLocation={gridItemRowLocation}
        dataInteraction={dataInteraction}
      />
    );
  });

  // productDescription
  const productWithOpenedDescription = rowProductsList
    .find((product) => product.id === briefDescriptionProductID);

  if (productWithOpenedDescription) {
    productGridRow.push(
      <ProductBriefDescription
        belowSponsoredGrid={rowProductsList.findIndex((product) => product.sponsored) !== -1}
        icons={productWithOpenedDescription.icons}
        descriptionShortened={productWithOpenedDescription.descriptionShortened}
        link={productWithOpenedDescription.link}
        productDescriptionLinkTranslation={getTranslation('productDescriptionLinkTranslation')}
        key={`brief-description-${productWithOpenedDescription.id}`}
      />
    );
  }

  // emailMeBack form
  if (rowProductsList
    .find((product) => product.id === emailWhenBackFormProductID)) {
    productGridRow.push(
      <EmailBack
        key={`email-back-${emailWhenBackFormProductID}`}
      />
    );
  }

  return productGridRow;

};

ProductGridRow.propTypes = {
  rowProductsList: PropTypes.arrayOf(PropTypes.object).isRequired,
  firstGridRow: PropTypes.bool,
  countdownClassSuffix: PropTypes.string,
  briefDescriptionProductID: PropTypes.string,
  emailWhenBackFormProductID: PropTypes.string,
  dataInteraction: PropTypes.string
};

ProductGridRow.defaultProps = {
  firstGridRow: false,
  countdownClassSuffix: null,
  briefDescriptionProductID: null,
  emailWhenBackFormProductID: null,
  dataInteraction: undefined
};

function mapStateToProps(state) {
  return {
    countdownClassSuffix: state.listingPage.commonData.countdownClassSuffix,
    briefDescriptionProductID: state.listingPage.commonData.briefDescriptionProductID,
    emailWhenBackFormProductID: state.listingPage.commonData.emailWhenBackFormProductID
  };
}

export default connect(mapStateToProps)(ProductGridRow);
